<script>
import layout from '@src/mixins/layout.vue'
import CollapsibleList from '@/src/components/tables/safehaven-collapsible-list.vue'
import { constants } from '@src/constants/safehaven'
import { optionsComputed } from '@state/helpers'
import { healthRecordService } from '@/src/services/safehaven/HealthRecordService'
import moment from 'moment'
import store from '@state/store'
import AddHrDialog from '@/src/components/dialogs/add-hr-dialog.vue'

export default {
  page: {
    title: 'Share Record View',
    meta: [{ name: 'description', content: 'The Share Record View page.' }],
  },
  components: { CollapsibleList, AddHrDialog },
  mixins: [layout],
  data() {
    return {
      resourceItem: '',
      addDialog: false,
      edit: false,
      response: '',
      expanded: true,
      hRecords: null,
      loading: false,
      recipientId: null,
      menuItems: constants.healthRecord,
    }
  },
  computed: {
    ...optionsComputed,
    computedMenuItems() {
      return this.menuItems
    },
  },

  mounted() {
    this.getAllDataPatinet()
  },

  methods: {
    editItem({ item, resource, attachments }) {
      const menuItem = this.getMenuItemFromResource(resource)
      // Give as a prop to add-hr-dialog the menuItem
      this.resourceMenuItem = menuItem
      // Give as a prop item
      item.patient_id = '1'
      this.resourceItem = item

      // Open dialog
      this.edit = true
      this.addDialog = true
      store.dispatch('calender/setAddNewRecords', 'false')

      if (attachments) {
        setTimeout(() => {
          store.dispatch('animations/setHighlightAttachments', true)
          const target = document.getElementById('#attachments')
          if (target) {
            this.$vuetify.goTo(target, {
              container: '#componentArea',
              duration: 800,
              easing: 'easeInOutCubic',
            })
          }
        }, 1000)
      }
    },
    getMenuItemFromResource(resource) {
      for (const key in this.menuItems) {
        if (this.menuItems[key].resource === resource) {
          return this.menuItems[key]
        }
      }
      return null
    },
    getExpiredDate(date) {
      return moment(date).format('MM/DD/YYYY')
    },
    getAllDataPatinet(data, index) {
      this.response = this.$route.query.responseData
      this.recipientId = this.$route.query.recipientId
      const healthRecords = this.$route.query.responseData.data
      localStorage.setItem(
        'sharedrecord',
        JSON.stringify(this.$route.query.responseData)
      )
      this.loading = true

      if (healthRecords) {
        this.hRecords = null
        this.hRecords = healthRecords.results

        healthRecordService.setHealthRecordData(healthRecords)
        store.dispatch(
          'calender/setSharedRecordTabs',
          this.$route.query.responseData
        )

        setTimeout(
          function() {
            this.loading = false
          }.bind(this),
          1000
        )
        document.getElementById('fetchData').click()
      }
    },

    closeDialodBox() {
      this.edit = false
      this.addDialog = false
    },
  },
}
</script>

<template>
  <v-container>
    <AddHrDialog
      v-if="addDialog"
      :group="resourceItem.group"
      :dialog.sync="addDialog"
      :edit.sync="edit"
      :menu.sync="resourceMenuItem"
      :item.sync="resourceItem"
      :show="true"
      :unauth="true"
      @close="closeDialodBox"
    ></AddHrDialog>
    <v-row class="mt-10">
      <v-col cols="12" sm="12" md="12" :lg="mobile ? 2 : 6" xl="2" fill-height>
        <h3 :class="$style.recordHeading"
          >Health Records for {{ response.sender_name }}</h3
        >
      </v-col>
    </v-row>
    <v-row class="pt-2">
      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
        <p :class="$style.topListNew">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :class="$style.btnClss"
                v-bind="attrs"
                @click="$store.dispatch('calender/setExpandAll', 'true')"
                v-on="on"
              >
                <img
                  :src="
                    require('@assets/images/Health-Record-Icons/icon-expand.svg')
                  "
                  class="imageproduit"
                />
              </v-btn>
            </template>
            <span>Expand All</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :class="$style.btnClss"
                v-bind="attrs"
                @click="$store.dispatch('calender/setExpandAll', 'false')"
                v-on="on"
              >
                <img
                  :src="
                    require('@assets/images/Health-Record-Icons/icon-collapse.svg')
                  "
                  class="imageproduit"
                />
              </v-btn>
            </template>
            <span>Collapse All</span>
          </v-tooltip>
        </p>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0"
        ><p :class="$style.expireClss" class="mb-0"
          >Your access to these records will
          <span class="font-weight-bold"
            >expire on {{ getExpiredDate(response.expiry_date) }}</span
          ></p
        ></v-col
      >
    </v-row>
    <div v-if="!loading">
      <v-row v-for="model in computedMenuItems" :key="model.plain_resource">
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          class="pt-0 pb-0"
          fill-height
        >
          <v-fade-transition mode="out-in">
            <CollapsibleList
              :icon="model.icon"
              :color="model.color"
              :opaque="model.opaque"
              :headers="model.headers"
              :sortables="model.sortables"
              :title="$t(model.title)"
              :subtitle="
                model.list_title ? $t(model.list_title) : $t(model.title)
              "
              :image="model.imageURL"
              :resource="model.resource"
              :records="hRecords"
              :shared="true"
              :recipientid="recipientId"
              @show-item="editItem"
            ></CollapsibleList>
          </v-fade-transition>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.recordHeading {
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 28.8px;
}

.expireClss {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #454648;
  text-align: right;
  letter-spacing: 0.1px;
}

.btnClss {
  padding: 0 !important;
  margin: 0 6px;
  font-size: 14px !important;
  color: #0476d9 !important;
  text-transform: capitalize;
  background: none !important;
  border: none;
  box-shadow: none !important;
}

.topListNew {
  padding: 0;
  color: #c4c4c4;
  text-align: right;
  text-align: left;
}

@media screen and (max-width: 959px) {
  .expireClss {
    text-align: left;
  }
  .topListNew {
    display: none;
  }
}
</style>
